<section class="prim-hero">
  <div class="prim-hero__greet">
    <h1 class="prim-hero__hi"
        [innerHTML]="'DASHBOARD.PRIMARY.GREETING' | translate:{ name: firstName }"></h1>
    <p class="prim-hero__sub">
      {{ 'DASHBOARD.PRIMARY.SUB_LINE1' | translate }}<br>
      {{ 'DASHBOARD.PRIMARY.SUB_LINE2' | translate }}
    </p>
  </div>

  <div class="prim-hero__mascot" aria-hidden="true">
    <svg viewBox="0 0 200 200" class="prim-mascot">
      <circle cx="100" cy="105" r="70" fill="var(--cyellow5)"/>
      <circle cx="100" cy="105" r="70" fill="none" stroke="var(--cdark1)" stroke-width="3"/>
      <circle cx="78" cy="92" r="9" fill="var(--cdark1)"/>
      <circle cx="122" cy="92" r="9" fill="var(--cdark1)"/>
      <circle cx="80" cy="89" r="3" fill="#fff"/>
      <circle cx="124" cy="89" r="3" fill="#fff"/>
      <path d="M75 120 Q100 142 125 120" stroke="var(--cdark1)" stroke-width="4" fill="none" stroke-linecap="round"/>
      <circle cx="62" cy="118" r="8" fill="var(--cred5)" opacity=".5"/>
      <circle cx="138" cy="118" r="8" fill="var(--cred5)" opacity=".5"/>
      <path d="M55 50 Q60 30 78 40 Z" fill="var(--cyellow5)" stroke="var(--cdark1)" stroke-width="3"/>
      <path d="M145 50 Q140 30 122 40 Z" fill="var(--cyellow5)" stroke="var(--cdark1)" stroke-width="3"/>
    </svg>
    <span class="prim-mascot__sparkle prim-mascot__sparkle--1">
      <i class="fa-solid fa-star"></i>
    </span>
    <span class="prim-mascot__sparkle prim-mascot__sparkle--2">
      <i class="fa-solid fa-sparkles"></i>
    </span>
  </div>
</section>
